<template>
  <div class="page">
    <div
      v-loading="table.loading"
      class="query-data"
    >
      <!-- list -->
      <el-table
        :data="table.list"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="id"
          label="类别"
          width="150"
        />
        <el-table-column
          prop="name"
          label="内容"
        />
        <el-table-column
          prop="max_level"
          label="最深层级"
        />
        <el-table-column
          fixed="right"
          label="操作"
          width="230"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="toSubList(scope.row)"
            >
              管理
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :current-page.sync="query.form.page"
        :page-sizes="[10, 20, 30, 50]"
        layout="total, sizes, prev, pager, next"
        :total="table.total"
        style="margin-top: 30px; float: right"
        @size-change="handlePageSizeChange"
        @current-change="handleQueryPage"
      />
    </div>
  </div>
</template>

<script>
import Request from '@/core/QuRequest';

const req = new Request();

export default {
  name: 'OperationManageDictList',
  data() {
    return {
      table: {
        list: [],
        total: 0,
        loading: false,
      },
      query: {
        form: {
          page: 1,
          page_size: 10,
        },
      },
    };
  },
  created() {
    this._getList();
  },
  methods: {
    // 获取列表数据
    async _getList() {
      try {
        const params = {
          ...this.query.form,
        };
        this.table.loading = true;
        // req
        const res = await req
          .send(req.Apis.sales.common.dictname, params)
          .fin(() => {
            this.table.loading = false;
          });
        const dv = res.data || {};
        this.table.list = [...(dv.data || [])];
        this.table.total = Number(dv.total || 0);
      } catch (err) {
        this.$message.error(`获取列表失败：${err.message || '未知错误'}`);
      }
    },

    // 页量改变
    handlePageSizeChange(pageSize) {
      this.query.form.page_size = Number(pageSize);
      this._getList();
    },

    // 页码改变
    handleQueryPage(page) {
      this.query.form.page = Number(page);
      this._getList();
    },

    // 跳转
    toSubList(o) {
      /**
       * type + level + id
       * level defaults to 1
       * id defaults to 0
       */
      const makeId = (o) => `${o.id || ''}-${1}-${0}`;
      this.$router.push({
        name: 'OperationManageDictSubList',
        params: {
          dictId: [makeId(o)],
        },
        query: {
          title: o.name || '',
          maxLevel: o.max_level || 1,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.query-data {
  // table
  .query-table {
    position: relative;
    overflow: hidden;
  }
}
</style>
